exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-5f14ed68],.fade-leave-active[data-v-5f14ed68]{transition:opacity .5s}.fade-enter[data-v-5f14ed68],.fade-leave-to[data-v-5f14ed68]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f14ed68","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Alert.vue
// module id = 618
// module chunks = 27